/** The task board frame: board, list and calendar views, display options, task chips. */
export default {
  boardTitleFallback: "Taskboard",
  display: "Display",
  tileTitle: "Task board",
  tileMatches: "{shown} of {total}",
  openBoard: "Open board",
  noOpenTasks: "No open tasks",
  noTasksMatch: "No tasks match “{query}”.",
  allProjects: "All",
  projectFilter: "Projects on this board",
  openTasksTruncated: "Only the most recently updated open tasks are shown",

  statusBacklog: "Backlog",
  statusTodo: "Todo",
  statusInProgress: "In progress",
  statusBlocked: "Blocked",
  statusInReview: "Ready for review",
  statusDone: "Done",

  priorityUrgent: "Urgent",
  priorityHigh: "High",
  priorityMedium: "Medium",
  priorityLow: "Low",

  overdue: "Overdue",
  yesterday: "Yesterday",
  today: "Today",
  tomorrow: "Tomorrow",
  thisWeek: "This week",
  nextWeek: "Next week",
  thisMonth: "This month",
  later: "Later",
  noDate: "No date",

  previousMonth: "Previous month",
  nextMonth: "Next month",
  closeDay: "Close day",
  moreTasks: "{count} more",
  noTasks: "No tasks",

  layout: "Layout",
  boardLayout: "Board layout",
  layoutBoard: "Board",
  layoutList: "List",
  layoutCalendar: "Calendar",
  hideCompleted: "Hide completed",
  sort: "Sort",
  sortAscending: "Sort ascending",
  sortDescending: "Sort descending",
  sortPriority: "Priority",
  sortDueDate: "Due date",
  sortCreated: "Created",
  sortStatus: "Status",
  sortAgent: "Agent",
  filter: "Filter",
  filtersActive: "{count} active",
  allTasks: "All tasks",
  all: "All",
  filterStatus: "Status",
  filterPriority: "Priority",
  filterAgent: "Agent",
  filterSource: "Source",
  filterCreated: "Created",
  sourceNote: "Note",
  sourceChat: "Chat",
  sourceHeartbeat: "Heartbeat",
  sourceSchedule: "Schedule",
  sourceCommentMention: "Comment mention",
  sourceTaskAssigned: "Task assigned",
  sourceDelegation: "Delegation",
  sourceEvent: "Event",
  sourceTemplate: "Project template",
  resetAll: "Reset all",

  waitingForAnswer: "Waiting for your answer",
  agentWorking: "{name} is working on this",
  someAgentWorking: "An agent is working on this",
  blockedBy: "Blocked by {ticket}",
  blockedByMore: "Blocked by {ticket} and {count} more",
  checksFailed: "Checks failed",
  openIn: "Open in {name}",
  openProjectIn: "Open project in {name}",
  subAgent: "Sub-agent",
  merged: "Merged",
  pushed: "Pushed",
  pullRequestNumber: "PR #{number}",
  shipWorkInProgress: "WIP",
  shipPlan: "Plan",
  shipReview: "Review",
  shipFix: "Fix",

  subtasks: { one: "{count} subtask", other: "{count} subtasks" },
  expandSubtasks: {
    one: "Expand {count} subtask",
    other: "Expand {count} subtasks",
  },
  collapseSubtasks: {
    one: "Collapse {count} subtask",
    other: "Collapse {count} subtasks",
  },
  selfParallelSubtasks: {
    one: "{count} self-parallel subtask",
    other: "{count} self-parallel subtasks",
  },
  parentFallback: "parent",
  openParentTask: "Open parent task {ticket}",

  // Desktop widget
  active: "active",
  activeCount: "{count} active",
} as const;
